import React, { useState } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import { MdDescription } from "react-icons/md";

export default function ConsentOfCare() {
  const [hovered, setHovered] = useState("t&c");

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "Terms & Conditions",
      active: hovered === "t&c" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("t&c"),
      onMouseLeave: () => setHovered("t&c"),
    },
  ];

  const termsSections = [
    {
      title: "1. Purpose of This Consent",
      desc: "This document provides consent for VeriMED and its affiliated physicians, nurses, care navigators, and wellness professionals to deliver medical and supportive care services to the above-named individual in the home, virtually, or at an affiliated clinic or wellness center.",
      items: null,
    },
    {
      title: "2. Scope of Consent",
      desc: "By signing this form, I authorize VeriMED to:",
      items: [
        "Conduct initial and ongoing medical evaluations, including home or virtual visits.",
        "Administer medications, treatments, nursing procedures, and wellness therapies deemed necessary for the patient's health and well-being.",
        "Share relevant medical information with assigned medical professionals and health team members involved in the care plan.",
        "Coordinate referrals to specialists, diagnostic labs, or other healthcare providers when necessary.",
        "Provide follow-up support and care navigation to ensure continuity of care.",
      ],
    },
    {
      title: "3. Understanding of Services",
      desc: "I understand that:",

      items: [
        "VeriMED offers personalized, concierge-style health services focused on personalized wellness, elder care, chronic disease management, and post-hospital support.",
        "Services may be provided in the patient’s home, virtually, or at designated VeriMED health facilities.",
        "Communication with the family in the home or abroad may occur via phone, WhatsApp, secure email, or a patient portal when available.",
        "I may request explanations of any recommended procedures or medications at any time.",
      ],
    },
    {
      title: "4. Consent for Telehealth Services",
      desc: "I understand that:",

      items: [
        "Some consultations, follow-ups, or care coordination may be conducted via video, phone, or secure messaging.",
        "These services are held to the same standards of confidentiality and professionalism as in-person visits.",
      ],
    },
    {
      title: "5. Emergency Situations",
      desc: "In the event of a health emergency while under VeriMED care:",

      items: [
        "I authorize VeriMED to take appropriate steps to stabilize and support the patient, including urgent referral or transport to a hospital or emergency provider.",
        "I understand that reasonable efforts will be made to contact the family/primary contact listed above as soon as possible.",
      ],
    },
    {
      title: "6. Confidentiality",
      desc: "I understand that all health information shared or collected will be treated as confidential in compliance with medical privacy standards and used solely for the purpose of care delivery and care coordination.",
      items: null,
    },
    {
      title: "7. Voluntary Participation",
      desc: "I understand that I (or the family member/patient listed above):",

      items: [
        "May refuse any treatment or service at any time.",
        "May withdraw consent in writing at any time.",
        "Have the right to ask questions and receive explanations about any aspect of the care plan.",
      ],
    },
    {
      title: "8. Financial Responsibility",
      desc: "I understand that:",

      items: [
        "Payment for services will be discussed in advance.",
        "Certain services may be part of a membership plan, while others may be billed on a per-visit basis.",
        "It is my responsibility (or the responsibility of the designated payer) to ensure timely payment for services rendered.",
      ],
    },
  ];

  return (
    <div className="terms_container">
      <Header />

      {/* Terms & Conditions Content */}
      <div className="terms_content">
        <div className="terms_header">
          <p>Verimed - Consent of Care</p>
          <p>11 December, 2025</p>
        </div>

        {termsSections.map((section, index) => (
          <div key={index} className="terms_section">
            <h2 className="terms_section_title">{section.title}</h2>
            {section.desc && (
              <p className="terms_section_desc">{section.desc}</p>
            )}
            {section.items && (
              <ul className="terms_section_list">
                {section.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
}
